<template>

<!-- new code -->
<div class="wrapper">
    <div class="str-logo">
        <span class="logo-lg">
            <img :src="$root.serverBasePath + '/strata.png'" alt="Strata Connex"
                    height="49px">
        </span>
    </div>

    <div class="content-wrapper">
        <!-- processbar -->
            <ProcessBar></ProcessBar>
        <!-- processbar ends -->

        <!-- content wrapper -->
        <div class="content-wrapper-form">
            <div class="register-form">
                    <h3 class="text-center mb-3">
                        Hey {{ $store.state.authenticatedUserData.user.first_name }},
                        let’s get you started
                    </h3>
                    <p class="text-center mb-2">
                        Short description about Strata Connex’s value proposition or
                        irresistable offer.
                    </p>
                    <hr />
                    <div class="prfle-completion-box py-2 px-4">
                        <h2 class="text-center prfle-complete mb-2">
                            Profile Completion
                        </h2>
                        <p class="text-center sub-prfle-txt">
                            Complete the following steps to have your compliance documents verified, or to have access to the compliance details of your contractors.
                        </p>
                        <div class="d-flex justify-content-between progress-tab">
                            <b-progress
                                :value="value"
                                :max="max"
                                class="mb-3"
                            ></b-progress>
                            <p style="font-size: 22px; padding-left: 10px;">33%</p>
                        </div>
                        <b-button
                            type="button"
                            variant="primary"
                            class="btn-grad"
                            :to="{ name: 'register-manager', params: { step: 2 } }"
                            >Start</b-button
                        >
                    </div>
                    <p class="mt-3 px-lg-5 px-md-2 review-section text-center">
                        “I hated submitting my compliance documents to a bunch of different companies. Now, I simply send my Strata Connex profile link which saves me so much time and effort!”
                    </p>

                    <div class="text-center mt-3">
                        <img :src="$root.serverBasePath + '/rev-avatar.png'" /><br />
                        <p class="avatar-name mt-3">
                            Paul Smith
                            <br /><span>Founder @ B2S Plumbing</span>
                        </p>
                    </div>
                </div>
        </div>
        <!-- content wrapper ends -->
    </div>

    <FooterComponent />

</div>
<!-- new code ends -->


</template>

<script>
import ProfileNav from "../includes/ProfileNav.vue";
import ProcessBar from "../../../../frontend/pages/includes/ProcessBar.vue";
import FooterComponent from "../../../../pages/includes/FooterComponent.vue";


export default {
    components: {
        ProfileNav,
        ProcessBar, FooterComponent,
    },
    data() {
        return {
            value: 33,
            max: 33
        };
    }
};
</script>

